@if (customer && projects) {
    <div class="container">
        <div class="header mt-2">
            <div class="row">
                <div class="col-auto">
                    <h2>Overzicht {{ viewOnyDrilling ? 'Booropdrachten' : '(deel)projecten' }}</h2>
                    <h1>{{ customer.name }}</h1>
                </div>
                <div class="col justify-content-start align-items-start d-flex">
                    @if (Features.CustomerProjectsSave | hasFeature) {
                        <button type="button" (click)="addProject()" class="button mx-0">Project toevoegen</button>
                    }
                    <a
                        class="button mx-0 ms-2"
                        routerLink="/{{ Routenames.customers }}/{{ customerId }}"
                        [queryParams]="{ workareaType: viewOnyDrilling ? 'Asfaltboringen' : 'Werkvakken' }">
                        Kaart openen
                    </a>
                    @if (!viewOnyDrilling && (Functionalities.CustomerProjectsManage | hasFunctionality)) {
                        <a
                            class="button mx-0 ms-2"
                            routerLink="/{{ Routenames.customers }}/{{ customerId }}/{{ Routenames.drillingProjects }}">
                            Booropdrachten
                        </a>
                    }
                    @if (viewOnyDrilling) {
                        <a
                            class="button mx-0 ms-2"
                            routerLink="/{{ Routenames.customers }}/{{ customerId }}/{{ Routenames.projects }}">
                            Projecten
                        </a>
                    }
                    @if (Functionalities.CustomerManagement | hasFunctionality) {
                        <button (click)="archive()" class="button mx-0 ms-2">Archiveren</button>
                    }
                </div>
                <div class="col-auto">
                    <app-customer-logo [customer]="customer"></app-customer-logo>
                </div>
            </div>
        </div>
    </div>

    <div class="container projects-container">
        <div class="projects">
            @if (projects.length === 0) {
                <p class="text-center w-100">
                    Er zijn nog geen (deel)projecten voor {{ customer.name }}.
                    @if (Features.CustomerProjectsSave | hasFeature) {
                        <button type="button" (click)="addProject()" class="button mt-3">Project toevoegen</button>
                    }
                </p>
            }
            @for (project of filteredProjects; track project.id) {
                <div class="project">
                    <div class="name">
                        <span>{{ project.name }}</span>
                        @if (project.has_access !== false && (Features.CustomerProjectsSave | hasFeature)) {
                            <i [routerLink]="[project.id, Routenames.edit]" class="fa fa-edit curpoint"></i>
                        }
                    </div>
                    @if (project.budget) {
                        <div class="budget">&euro; {{ project.budget | number: '0.0-2' }}</div>
                    }
                    <div class="divider"></div>
                    <div class="manager">
                        {{ project.manager_user?.name }}
                    </div>
                    @if (project?.customer_project_phase?.name) {
                        <div class="current-phase">Huidige fase: {{ project?.customer_project_phase?.name }}</div>
                    }
                    @if (viewOnyDrilling) {
                        <div class="current-phase">
                            Uitvoeringsdatum:
                            {{ (project?.extra?.execution_date | date: 'd MMMM yyyy') || 'onbekend' }}
                        </div>
                    }
                    <div class="divider"></div>
                    @if (projectsCounts && projectsCounts[project.id]) {
                        <table class="table-fixed">
                            @for (count of projectsCounts[project.id]; track count.name) {
                                <tr>
                                    <td>
                                        <div [innerHTML]="count.count | marker: count.colorcode"></div>
                                    </td>
                                    <td>{{ count.name }}</td>
                                </tr>
                            }
                        </table>
                    }
                    @if (customerId) {
                        <a
                            [queryParams]="{ project: project.id }"
                            class="tomap"
                            routerLink="/{{ Routenames.customers }}/{{ project.customer_id }}">
                            Projectdelen op kaart bekijken &raquo;
                        </a>
                    }
                    @if (pendingAccessCounts[project.id]) {
                        <div class="pending-access">
                            <i class="fas fa-user-clock me-1"></i>
                            {{ pendingAccessCounts[project.id] }}
                            {{ pendingAccessCounts[project.id] === 1 ? 'toegangsverzoek' : 'toegangsverzoeken' }}
                        </div>
                    }
                    @if (project.has_access !== false && (Features.CustomerProjectsDetail | hasFeature)) {
                        <a
                            class="button"
                            routerLink="/{{ Routenames.customers }}/{{ project.customer_id || 'template' }}/{{
                                viewOnyDrilling ? Routenames.drillingProjects : Routenames.projects
                            }}/{{ project.id }}">
                            Bekijk project
                        </a>
                    } @else if (
                        project.has_access === false && (Features.CustomerProjectsDetailAccessRequestSave | hasFeature)
                    ) {
                        <a [routerLink]="[project.id, Routenames.requestAccess]" class="button">
                            {{ project.access_requested ? 'Toegang aangevraagd' : 'Toegang aanvragen' }}
                        </a>
                    }
                </div>
            }
        </div>
    </div>
}
<ng-template #projectFilterSearchTemplate>
    <mat-form-field>
        <mat-label>Filter</mat-label>
        <mat-select multiple [(ngModel)]="projectFilter" (selectionChange)="loadProjects()">
            @for (type of Settings.projectTypes; track type.key) {
                @if (type.key !== 'drillings' || (Functionalities.CustomerProjectsManage | hasFunctionality)) {
                    <mat-option [value]="type.key" [hidden]="viewOnyDrilling">
                        {{ type.name }}
                    </mat-option>
                }
            }
            <mat-option value="archive"> Gearchiveerd </mat-option>
        </mat-select>
    </mat-form-field>
</ng-template>
